<mat-dialog-content>
  <events-event-editor
    [groupId]="groupId"
    [startDate]="startDate"
    [eventId]="eventId"
    (eventSaved)="afterSaved($event)"
  >
  </events-event-editor>
</mat-dialog-content>
